import { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import axios from "axios";
import { baseURl } from "BaseUrl";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import noUser from "assets/images/XDream Logo.svg"
// import noUser from "assets/images/Aai-logo.png";
import { Tooltip } from "@mui/material";
import moment from "moment";
import LoadingAnimation from "components/Animation/LoadingAnimation";

export const getData = async (count, search, limit, total) => {
  try {
    const res = await axios.get(`${baseURl}/user/admin/getAllUsers?page=${count}&search=${search}&limit=${limit}`);
    const allUsers = res.data.users;
    const data = res.data;
    const total = res.data.total_count;

    return {
      users: allUsers,
      total,
      pageLimit: Math.floor(total / limit + 1),
      data: data,
    };
  } catch (err) {
    console.log(err);
  }
};

export default function data() {
  const Author = ({ image, name, email, status }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar src={image} name={name} size="sm" />
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
      <MDBox ml={5}>{status}</MDBox>
    </MDBox>
  );

  const Job = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography
        display="block"
        variant="caption"
        color="text"
        fontWeight="medium"
      >
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  const [count, setCount] = useState(1);
  const [users, setUsers] = useState([]);
  const [data, setData] = useState("");
  const [search, setSearch] = useState("");
  const [total, setTotal] = useState();
  const [limit, setLimit] = useState(10);
  const [pageLimit, setPageLimit] = useState();
  const [loading, setLoading] = useState(true);

  const userData = async () => {
    const { users, data, pageLimit } = await getData(
      count,
      search,
      limit,
    );
    setData(data);
    setLoading(false);
    setUsers(users);
    setTotal(total);
    setPageLimit(pageLimit);
  };

  useEffect(() => {
    userData();
  }, [count, search, limit]);

  return {
    columns: [
      { Header: "NAME", accessor: "author", align: "left", width: "20%" },
      { Header: "PLAN", accessor: "employed", align: "center" },
      { Header: "DAta left", accessor: "action", align: "center" },
      { Header: "USER CREATED AT", accessor: "created", align: "center" },
    ],

    rows: users?.map((user) => ({
      row: user,
      author: (
        <Author
          image={user?.image || noUser}
          name={user?.name || "Not available"}
          email={(user?.email || user?.phone_number) || "not available"}
          status=<MDBox ml={-1}>
            {user.email_verified_at || user?.plan_start ? (
              <Tooltip title={user?.plan_start ? "subscriber" : "verified"}>
                <MDBadge
                  badgeContent=<CheckCircleIcon />
                  color={user.plan_start ? "info" : "success"}
                  variant="gradient"
                  size="sm"
                />
              </Tooltip>
            ) : (
              <Tooltip title="not verified">
                <MDBadge
                  badgeContent=<CancelIcon />
                  color="error"
                  variant="gradient"
                  size="sm"
                />
              </Tooltip>
            )}
          </MDBox>
        />
      ),

      employed: (
        <MDTypography
          component="a"
          href="#"
          variant="caption"
          color="text"
          fontWeight="medium"
        >
          {user?.plan}
        </MDTypography>
      ),
      action: (
        <Job
          title={`Text : ${user?.text_count_left}`}
          description={`Image: ${user?.image_count_left}`}
        />
      ),
      created: (
        <MDTypography
          component="a"
          href="#"
          variant="caption"
          color="text"
          fontWeight="medium"
        >
          {moment(user?.createdAt).format("DD/MM/YYYY,h:mm:ss a")}
        </MDTypography>
      ),
    })),
    total, total,
    data: data,
    loading: loading,
    search: search,
    setSearch: setSearch,
    pageLimit: pageLimit,
    limit: limit,
    setLimit: setLimit,
    count: count,
    setCount: setCount,
  };
}
